import React, {Component} from 'react';
import Modal from 'react-bootstrap-modal';
import {Redirect} from 'components/ReactRouterDomLocalized';

import ProfileLink from 'components/ProfileLink';

import ModalFaqBlock from '../faq/ModalFaqBlock';

import {t, dt} from 'l10n';

import 'sass/modals/modalGiveVirtualGift.scss';

import {saveVirtualGift} from 'backend-helpers/member';
import {
    GIFT_ANONYMITY_NOBODY,
    GIFT_ANONYMITY_PUBLIC,
    GIFT_ANONYMITY_RECIPIENT,
    GIFT_SEND_RESULT_INSUFFICIENT_AMOUNT,
    GIFT_SEND_RESULT_SENT
} from 'constants/virtualGifts';

import paths from 'paths';

const STATE_PENDING = 'pending',
    STATE_PROCESSING = 'processing',
    STATE_ERROR = 'error',
    STATE_DONE = 'done';

class ModalGiveVirtualGift extends Component {
    constructor(props) {
        super(props);

        this.state = {
            anon: props.virtualGift ? props.virtualGift.anon : GIFT_ANONYMITY_PUBLIC,
            comment: props.virtualGift ? props.virtualGift.comment : '',
            attachmentToUploadSrc: null,
            errorMessage: null,
            doneRedirect: null,
            state: STATE_PENDING
        };

        this.onFileInputChange = this.onFileInputChange.bind(this);
        this.onSubmitButtonClick = this.onSubmitButtonClick.bind(this);
        this.onSendSuccess = this.onSendSuccess.bind(this);
        this.onSaveSuccess = this.onSaveSuccess.bind(this);
        this.onSubmitError = this.onSubmitError.bind(this);
    }

    onFileInputChange(event) {
        event.preventDefault();

        if(this.state.state === STATE_PROCESSING) {
            return false;
        }

        this.setState({state: STATE_PROCESSING});

        let files;
        if (event.dataTransfer) {
            files = event.dataTransfer.files;
        } else if (event.target) {
            files = event.target.files;
        }

        const reader = new FileReader();
        reader.onload = () => {
            this.setState({attachmentToUploadSrc: reader.result, state: STATE_PENDING});
        };
        reader.readAsDataURL(files[0]);
    }

    onSubmitButtonClick(event, additionalData) {
        event.preventDefault();

        if(this.state.state === STATE_PROCESSING) {
            return false;
        }

        this.setState({errorMessage: null, state: STATE_PROCESSING});

        let {giftCatalogItem, virtualGift, user} = this.props;
        let {anon, comment} = this.state;

        let formData = {
            recipient: user.nick,
            anon,
            comment,
            attachment: this.fileInput.files[0] || null,
            ...additionalData
        };

        if (giftCatalogItem) formData.gift_id = giftCatalogItem.id;
        if (virtualGift) formData.id = virtualGift.id;

        let onSubmitSuccess = function() {};
        if (additionalData.hasOwnProperty('save')) {
            onSubmitSuccess = this.onSaveSuccess;
        } else if (additionalData.hasOwnProperty('give')) {
            onSubmitSuccess = this.onSendSuccess;
        }

        saveVirtualGift(formData)
            .then(onSubmitSuccess)
            .catch(this.onSubmitError);

        return false;
    }

    onSendSuccess({result, giftId}) {
        let {user} = this.props;

        let successfulPath = paths.profile.toPath({nick: user.nick});

        if (result === GIFT_SEND_RESULT_SENT) {
            this.setState({doneRedirect: successfulPath});
        } else if (result === GIFT_SEND_RESULT_INSUFFICIENT_AMOUNT) {
            this.setState({
                doneRedirect: {
                    // pathname: paths.memberWalletReplenish.path,
                    pathname: paths.paymentOrder.path,
                    search: '?gift_id='+encodeURIComponent(giftId)+'&return_path='+encodeURIComponent(successfulPath)
                }
            });
        }

    }

    onSaveSuccess() {
        let {onSaveSuccess} = this.props;
        this.setState({doneRedirect: paths.memberWallet.path, state: STATE_DONE});
        if (typeof onSaveSuccess == 'function') onSaveSuccess();
    }

    onSubmitError(error) {
        this.setState({errorMessage: error.messages || error.message, state: STATE_ERROR});
    }

    render() {
        let {giftCatalogItem, virtualGift, user, currentUser, show, closeFn} = this.props;

        let {attachmentToUploadSrc, errorMessage, doneRedirect} = this.state;

        if (doneRedirect) {
            return <Redirect to={doneRedirect}/>
        }

        let attachmentSrc;
        if (virtualGift && virtualGift.attachment) {
            attachmentSrc = virtualGift.attachment.thumbnail_url;
        }
        if (attachmentToUploadSrc) {
            attachmentSrc = attachmentToUploadSrc;
        }

        if (!show || !user || !currentUser.isLoggedIn()) return null;

        return (
            <Modal
                className="modalGiveVirtualGift ui-kit-base"
                show={show}
                onHide={closeFn}
                onExited={() => this.setState({doneRedirect: null, state: STATE_PENDING})}
            >
                <Modal.Body>
                    <div className="close" onClick={closeFn}/>
                    
                    <h2 className="ui-header">{t('Give a virtual gift')}</h2>

                    <form>
                        {errorMessage && <div className="error"><p>{errorMessage}</p></div>}

                        <div className="inside">
                            <div className="left">
                                <img className="virtual-gift-thumbnail" src={giftCatalogItem ? giftCatalogItem.thumbnail_url : virtualGift.thumbnail_url} alt=""/>
                            </div>

                            <div className="right">
                                <h2 className="ui-header">{giftCatalogItem ? giftCatalogItem.name : virtualGift.name}</h2>
                                <h3 className="ui-header">{dt('xxl', '%1 tokens', giftCatalogItem ? giftCatalogItem.points : virtualGift.points)}</h3>

                                <div className="ui-input">
                                    <button className="ui-button primary" disabled={this.state.state === STATE_PROCESSING} onClick={(e) => this.onSubmitButtonClick(e, {give: 1})}>{t('Give this virtual gift')}</button>
                                </div>

                                <div className="ui-input">
                                    <button className="ui-button secondary" disabled={this.state.state === STATE_PROCESSING} onClick={(e) => this.onSubmitButtonClick(e, {save: 1})}>{dt('virtual_gifts', 'Put on hold')}</button>
                                </div>

                                <div className="ui-input">{t('From:')} <ProfileLink user={currentUser} target="_blank"/></div>
                                <div className="ui-input">{t('To:')} <ProfileLink user={user} target="_blank"/></div>
                            </div>
                        </div>

                        <div className="inside row-2">
                            <div className="left">
                                <label className="ui-label ui-mini">{t('Attachment:')}</label>
                                <img src={attachmentSrc} className="attachment-preview"/>
                                <input type="file" name="attachment" accept="image/jpeg" ref={(ref) => this.fileInput = ref} onChange={this.onFileInputChange}/>
                                <a className="ui-button" disabled={this.state.state === STATE_PROCESSING} onClick={() => this.fileInput.dispatchEvent(new MouseEvent('click', {}))}>{t('Choose file')}</a>
                            </div>
                            <div className="right">
                                <label className="ui-label ui-mini">{t('Expose you nick to:')}</label>

                                <div className="ui-input compact">
                                    <input type="radio" checked={this.state.anon == GIFT_ANONYMITY_PUBLIC ? 'checked' : ''}
                                           onChange={(e) => e.target.checked && this.setState({anon: GIFT_ANONYMITY_PUBLIC})}
                                           id="radio-anon-1" className="ui-radio-2"/>
                                    <label htmlFor="radio-anon-1">{dt('virtual_gifts', 'All')}</label>
                                </div>

                                <div className="ui-input compact">
                                    <input type="radio" checked={this.state.anon == GIFT_ANONYMITY_RECIPIENT ? 'checked' : ''}
                                           onChange={(e) => e.target.checked && this.setState({anon: GIFT_ANONYMITY_RECIPIENT})}
                                           id="radio-anon-2" className="ui-radio-2"/>
                                    <label htmlFor="radio-anon-2">{dt('virtual_gifts', 'Recipient only')}</label>
                                </div>

                                <div className="ui-input compact">
                                    <input type="radio" checked={this.state.anon == GIFT_ANONYMITY_NOBODY ? 'checked' : ''}
                                           onChange={(e) => e.target.checked && this.setState({anon: GIFT_ANONYMITY_NOBODY})}
                                           id="radio-anon-3" className="ui-radio-2"/>
                                    <label htmlFor="radio-anon-3">{dt('virtual_gifts', 'Nobody')}</label>
                                </div>
                            </div>
                        </div>

                        <label htmlFor="" className="ui-label ui-mini">{t('Private message (optional):')}</label>
                        <textarea name="comment" onChange={(e) => this.setState({comment: e.target.value})} value={this.state.comment} className="ui-text-input"/>
                    </form>

                    <ModalFaqBlock items={[
                        t('By giving this virtual gift, your virtual wallet will be debited with the number of tokens corresponding to the value of the gift.'),
                        t('You can attach a message and/or a photo to this virtual gift. This message and this picture will remain confidential, only the recipient can see them.'),
                        t('Your virtual gift (without your message and your photo) will be displayed on the profile page of the recipient.'),
                        t('You can choose between 3 options:'),
                        t('- Show your nickname to: All'),
                        t('Your nickname will be visible to all users on the profile page of the recipient.'),
                        t('- Show your nickname to: Recipient only'),
                        t('Your nickname will be visible only to the recipient.'),
                        t('- Show your nickname to: Nobody'),
                        t('Your nickname will not be visible neither to the recipient nor to other users.'),
                        t('Your virtual gift will be anonymous.')
                    ]}/>
                </Modal.Body>
            </Modal>
        )
    }
}

export default ModalGiveVirtualGift;


// WEBPACK FOOTER //
// ./src/components/modals/ModalGiveVirtualGift.js